import { Checkbox } from "@mui/material";
import SC from "./style";
import theme from "@theme/";
const UserComponent = (props) => {
  const { user, occupantId, roleId, isUserSelected, toggleUserSelection } =
    props;
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Checkbox
          checked={isUserSelected(occupantId, roleId, user.id)}
          onChange={() => toggleUserSelection(occupantId, roleId, user.id)}
          sx={{
            "&.Mui-checked": {
              color: theme.colors.themeColor,
            },
            padding: "0px",
          }}
          size="small"
        />
        <span>{user.fullName}</span>
      </div>
    </>
  );
};

export default UserComponent;
